export default __webpack_public_path__ + "static/media/zero_sac_3.39c15c87.png";